import { getCurrentConfiguration, isServerSide } from "../utils";
/**
 * @deprecated you should use `useConfig` hook instead from `@jti/ui` package
 * @returns {Config} - returns the current configuration
 */
export const getConfig = () => {
    if (isServerSide()) {
        console.warn("getConfig will not work on server side. Please refactor to use useConfig hook instead.");
        return {};
    }
    const config = getCurrentConfiguration();
    return config;
};
/**
 * @deprecated you should use `useLocale` hook instead from `@jti/ui` package
 * @returns {string} - returns the current locale
 */
export const getLocale = () => {
    if (isServerSide()) {
        return "en";
    }
    return window.document.documentElement.lang || "en";
};
export const isCommerceInactive = () => !!window.document.querySelector(`meta[property="commerce-disabled"],meta[name="commerce-disabled"]`);
export const isFreeTrialActive = () => {
    const config = getConfig();
    return config.FREE_TRIAL_FEATURE_FLAG === "true" && config["trials-store-view"] !== undefined;
};
export const hasFreeTrialDashboard = () => {
    const config = getConfig();
    return ((config.FREE_TRIAL_USER_DASHBOARD_SHOW === "true" || !config.DISABLE_USER_DASHBOARD_FREE_TRIAL) &&
        isFreeTrialActive());
};
export const hasDevicesDashboard = () => !getConfig().DISABLE_USER_DASHBOARD_DEVICES;
export const hasTranslationTool = (config) => config.TRANSLATION_TOOL === "true";
//# sourceMappingURL=config.js.map